import ActionType from './ActionType';
import {
	PressReleaseReserveRequestModel,
	PressReleaseReserveModel,
    PressReleaseReserveReviewModel,
	PressReleaseReserveReviewResultModel,
	ReserveMediaRecommendModel,
	SetPressReleaseSendListModel,
	PostMailCheckRequestModel,
	SetPressReleaseReserveCategoryModel,
} from "../../model/PressReleaseReserveModel";
import { createAsyncAction, createStandardAction } from 'typesafe-actions';


export const postPressReleaseMediaRecommend = createAsyncAction(
	ActionType.POST_PRESS_RELEASE_MEDIA_RECOMMEND_REQUEST,
	ActionType.POST_PRESS_RELEASE_MEDIA_RECOMMEND_SUCCEEDED,
	ActionType.POST_PRESS_RELEASE_MEDIA_RECOMMEND_FAILED
)<ReserveMediaRecommendModel, ReserveMediaRecommendModel, Error>();

export const getPressReleaseReserve = createAsyncAction(
    ActionType.GET_PRESS_RELEASE_RESERVE_REQUEST,
    ActionType.GET_PRESS_RELEASE_RESERVE_SUCCEEDED,
    ActionType.GET_PRESS_RELEASE_RESERVE_FAILED
)<PressReleaseReserveRequestModel, PressReleaseReserveModel, Error>();

export const postPressReleaseReserve = createAsyncAction(
	ActionType.POST_PRESS_RELEASE_RESERVE_REQUEST,
	ActionType.POST_PRESS_RELEASE_RESERVE_SUCCEEDED,
	ActionType.POST_PRESS_RELEASE_RESERVE_FAILED
)<PressReleaseReserveReviewModel, void, Error>();

export const deletePressReleaseReserve = createAsyncAction(
	ActionType.DELETE_PRESS_RELEASE_RESERVE_REQUEST,
	ActionType.DELETE_PRESS_RELEASE_RESERVE_SUCCEEDED,
	ActionType.DELETE_PRESS_RELEASE_RESERVE_FAILED
)<void, void, Error>();


export const getPressReleaseCustomMedia = createAsyncAction(
	ActionType.GET_PRESS_RELEASE_CUSTOM_MEDIA_REQUEST,
	ActionType.GET_PRESS_RELEASE_CUSTOM_MEDIA_SUCCEEDED,
	ActionType.GET_PRESS_RELEASE_CUSTOM_MEDIA_FAILED
)<void, PressReleaseReserveModel, Error>();

export const getPressReleaseAutoMedia = createAsyncAction(
	ActionType.GET_PRESS_RELEASE_AUTO_MEDIA_REQUEST,
	ActionType.GET_PRESS_RELEASE_AUTO_MEDIA_SUCCEEDED,
	ActionType.GET_PRESS_RELEASE_AUTO_MEDIA_FAILED
)<void, PressReleaseReserveModel, Error>();


export const postPressReleaseReserveReviewResult = createAsyncAction(
	ActionType.POST_PRESS_RELEASE_RESERVE_REVIEW_RESULT_REQUEST,
	ActionType.POST_PRESS_RELEASE_RESERVE_REVIEW_RESULT_SUCCEEDED,
	ActionType.POST_PRESS_RELEASE_RESERVE_REVIEW_RESULT_FAILED
)<PressReleaseReserveReviewResultModel, PressReleaseReserveModel, Error>();


export const setPressReleaseReserveCustom = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_CUSTOM,
	'',
	'',
)<any, void, void>();


export const setPressReleaseReserveAuto = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_AUTO,
	'',
	'',
)<any, void, void>();


export const setPressReleaseReserveDatetime = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_DATETIME,
	'',
	'',
)<Date, void, void>();


export const setPressReleaseReserveCopy = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_COPY,
	'',
	'',
)<any, void, void>();

export const setPressReleaseReserveActive = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_ACTIVE,
	'',
	'',
)<number, void, void>();


export const setPressReleaseReserveReview = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_REVIEW,
	'',
	'',
)<PressReleaseReserveReviewModel, void, Error>();

export const setPressReleaseReserveAutoMedia = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_AUTO_MEDIA,
	'',
	'',
)<PressReleaseReserveReviewModel, void, Error>();

export const setPressReleaseReserveSaveLoading = createStandardAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_SAVE_LOADING,
)<boolean>();

export const setAttachedPressKitId = createStandardAction(
	ActionType.SET_ATTACHED_PRESS_KIT_ID
)<Array<String>>();

export const setPressReleaseReserveAutoMediaList = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_AUTO_MEDIA_LIST,
	'',
	''
)<number[], void, Error>();

export const addPressReleaseReserveAutoMediaAll = createAsyncAction(
	ActionType.ADD_PRESS_RELEASE_RESERVE_MEDIA_ALL,
	'',
	'',
)<number[], void, Error>();

export const removePressReleaseReserveAutoMediaAll = createAsyncAction(
	ActionType.REMOVE_PRESS_RELEASE_RESERVE_MEDIA_ALL,
	'',
	'',
)<void, void, Error>();

export const setMediaListId = createAsyncAction(
	ActionType.SET_MEDIA_LIST_ID,
	'',
	'',
)<number, void ,Error>();

export const postMailCheck = createAsyncAction(
	ActionType.POST_MAIL_CHECK_REQUEST,
	ActionType.POST_MAIL_CHECK_SUCCEEDED,
	ActionType.POST_MAIL_CHECK_FAILED,
)<PostMailCheckRequestModel, any, Error | string>();

export const setPressReleaseReserveCategory = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_CATEGORY,
	'',
	'',
)<SetPressReleaseReserveCategoryModel, void ,Error>();

export const setPressReleaseReserveType = createAsyncAction(
	ActionType.SET_PRESS_RELEASE_RESERVE_TYPE,
	'',
	'',
)<number, void ,Error>();

export const clearPressReleaseReserveState = createAsyncAction(
	ActionType.CLEAR_PRESS_RELEASE_RESERVE_STATE,
	'',
	'',
)<void, void, Error>();
